<template>
  <div class="lucky_draw_wrap">
    <div class="first_wrap" :style="{height: first_h+'px'}">
      <!-- <div class="bg">
        <img src="@/assets/imgs/luckyDraw/newyear/head_bg.png" alt="" />
      </div> -->
      <div class="logo">
        <img src="@/assets/imgs/voucherCenter/LOGO.png" alt="3dm网游加速器" />
      </div>
      <div class="login_wrap">
        <a href="javascript:void(0)" v-if="!token" class="btn" @click="openLoginPage"
          >登录/注册</a
        >
        <div v-else class="personal">
          <img class="avatar" :src="userInfo.head_image_url" alt />
          <div class="userinfo">
            <div>您好，亲爱的【 <span class="username">{{userInfo.nick_name || userInfo.user_phone}}</span> 】 <span class="logout_btn" @click="logout">退出</span></div>
            <span>VIP剩余时长： <span class="remainTime">{{userInfo.remain_accelerate_time || '0天'}}</span></span>
          </div>
        </div>
      </div>
    </div>
    <div class="active_wrap" id="active_wrap">
      <div class="title_wrap">
        <img src="@/assets/imgs/luckyDraw/newyear/title_1.png" alt="" class="title">
      </div>
      <div class="product_wrap">
        <div class="top">
          <div class="product">
            <div class="left">
              <img src="@/assets/imgs/luckyDraw/newyear/two.png" alt="">
            </div>
            <div class="right">
              <div class="top">
                <img src="@/assets/imgs/luckyDraw/newyear/double.png" alt="">
              </div>
              <div class="bottom">
                <span class="pay_btn" @click="purchase(activeProduct[0])"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="product">
            <div class="left">
              <img src="@/assets/imgs/luckyDraw/newyear/chance.png" alt="">
            </div>
            <div class="right">
              <img src="@/assets/imgs/luckyDraw/newyear/one.png" alt="">
              <span class="pay_btn" @click="purchase(activeProduct[1])"></span>
            </div>
          </div>
          
          <div class="product">
            <div class="left">
              <img src="@/assets/imgs/luckyDraw/newyear/chance.png" alt="">
            </div>
            <div class="right">
              <div class="top">
                <img src="@/assets/imgs/luckyDraw/newyear/half.png" alt="">
              </div>
              <div class="bottom">
                <span class="pay_btn" @click="purchase(activeProduct[2])"></span>
              </div>
            </div>
          </div>
          
          <div class="product">
            <div class="left">
              <img src="@/assets/imgs/luckyDraw/newyear/chance.png" alt="">
            </div>
            <div class="right">
              <div class="top">
                <img src="@/assets/imgs/luckyDraw/newyear/quarter.png" alt="">
              </div>
              <div class="bottom">
                <span class="pay_btn" @click="purchase(activeProduct[3])"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="decoration_wrap">
        <img src="@/assets/imgs/luckyDraw/newyear/leaf_left_2.png" alt="" class="decoration">
      </div>
      <div class="decoration_wrap_r">
        <img src="@/assets/imgs/luckyDraw/newyear/leaf_right.png" alt="" class="decoration">
      </div>
    </div>
    <div class="lucky_wrap" id="lucky_wrap">
      <div class="title_wrap">
        <img src="@/assets/imgs/luckyDraw/newyear/title_2.png" alt="" class="title">
      </div>
      <div class="draw_wrap">
        <div class="bottom">
          <div class="left">
            <LuckyGrid
              ref="myLucky"
              width="880px"
              height="640px"
              :prizes="prizes"
              :blocks="blocks"
              :buttons="buttons"
              :defaultStyle='defaultStyle'
              :activeStyle='activeStyle'
              :defaultConfig='defaultConfig'
              @start="startCallback"
              @end="endCallback"
            />
          </div>
          <div class="right">
            <div class="list">
              <div class="list_header">
                <img src="@/assets/imgs/luckyDraw/newyear/record_title.png" alt="">
              </div>
              <div class="divider">
                <img src="@/assets/imgs/luckyDraw/newyear/divider.png" alt="">
              </div>
              <vue-seamless-scroll :data="records" class="seamless-warp" :step='1'>
                <ul class="item_wrap">
                    <li v-for="(item,index) in records" :key="index" class="item">
                      <span class="tips">恭喜<span class="user_name">{{item.user_name ? formatName(item.user_name) : formatName(item.user_phone,'phone')}}</span>获得奖品</span>
                      <span class="prize_name">《{{item.prize_name}}》</span>
                    </li>
                </ul>
              </vue-seamless-scroll>
              <div class="list_footer" @click="openLayerRecord">
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="decoration_wrap">
        <img src="@/assets/imgs/luckyDraw/newyear/leaf_left.png" alt="" class="decoration">
      </div>
    </div>
    <div class="free_wrap">
      <div class="title_wrap">
        <img src="@/assets/imgs/luckyDraw/newyear/title_3.png" alt="" class="title">
      </div>
      <div class="free_game_wrap">
        <div v-for="(item, index) in freeGame" :key="index" class="game">
          <img :src="item" alt="">
        </div>
      </div>
      <div class="decoration_wrap">
        <img src="@/assets/imgs/luckyDraw/newyear/leaf_right_2.png" alt="" class="decoration">
      </div>
    </div>
    <div class="rule_wrap">
      <div class="title_wrap">
        <img src="@/assets/imgs/luckyDraw/newyear/title_4.png" alt="" class="title">
      </div>
      <div class="rule">
        <span v-html="activeInfo.description" style="white-space: pre-wrap"></span>
      </div>
    </div>

    <!-- 支付弹窗 -->
    <transition name="fade">
      <div class="layer" v-show="layerShow">
        <div class="layer-title">
          <div class="title">充值</div>
          <span class="el-icon-close" @click="closeLayer"></span>
        </div>
        <div class="layer-content">
          <div class="pay-code" @contextmenu.prevent.stop>
            <div
              class="qr-code"
              ref="qrCode"
              :class="{ loading: qrLoading }"
            ></div>
            <div class="scan" v-show="!qrLoading"></div>
            <div class="qr-loading" v-show="qrLoading"></div>
          </div>
          <div class="pay-info">
            <h5 class="sum">
              <span class="icon">¥</span>
              <span class="integer">{{ parseInt(pay_amount) }}</span>
              <span class="float">{{ getPriceFloat(pay_amount) }}</span>
            </h5>
            <span class="discount" v-if="coupon_discount>0">(券后优惠：{{coupon_discount}}元)</span>
            <h5 class="tips">
              打开{{ form.payWay | translateToName(payWays) }}扫码完成支付
            </h5>
            <div class="operate">
              <div class="payWay wechat" :class="form.payWay == 'wx_qrcode' ? 'selected':''" @click="checkPayWay('wx_qrcode')">微信</div>
              <div class="payWay alipay" :class="form.payWay == 'ali_qrcode' ? 'selected':''" @click="checkPayWay('ali_qrcode')">支付宝</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="layer-shadow" v-show="layerShow" @click="closeLayer"></div>

    <!-- 用户中奖记录 -->
    <el-dialog
      title="中奖记录"
      :visible.sync="layerShowRecord"
      width="700px"
      custom-class="record-dialog"
      append-to-body
    >
      <el-table
        :data="userRecord"
        style="width: 100%"
        :cell-style="{ color: '#fff' }"
        :header-cell-style="{ color: '#fff' }"
        empty-text='暂无中奖数据'
      >
        <el-table-column
          prop="prize_name"
          label="奖品"
          width="180">
        </el-table-column>
        <el-table-column
          prop="name"
          label="奖品详情"
          width="240">
          <template slot-scope="scope">
            <span>{{showPrizeDetail(scope.row)}}</span>
            <!-- <span v-if="scope.row.prize_name == '会员充值免单券' || scope.row.prize_name == '会员充值买一送一' || scope.row.prize_name == '500元游戏随心购'">请截图联系客服领取(联系方式请查看活动规则)</span>
            <span v-if="scope.row.resource_type== 'coupons' || scope.row.resource_type == 'duration_card'">已发放至账户卡券包</span> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="draw_at"
          label="中奖时间">
        </el-table-column>
      </el-table>
    </el-dialog>
    
    <!-- 登录弹窗 -->
    <el-dialog
      title="登录/注册"
      :visible.sync="showLoginDialog"
      width="528px"
      custom-class="login-dialog"
      append-to-body
    >
      <login v-if="showLoginDialog" :zoomValue="zoomValue"/>
    </el-dialog>

    <!-- <img class="dl_btn" src="@/assets/imgs/luckyDraw/dl.png" alt="点击下载客户端" title="点击下载客户端" @click="getWinHref"> -->
    <!-- 活动结束提示 -->
    <el-dialog
      title="温馨提示"
      :visible.sync="layerShowTips"
      width="700px"
      custom-class="tips-dialog"
      append-to-body
    >
      <div class="tips">
        <span>活动已结束</span>
        <span>持续关注消息，下次不要错过啦~</span>
        <div class="tip_btn" @click="layerShowTips = false">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getActiveInfo, getLuckyDrawRecord, getLuckyDrawCount, startLuckyDraw, getUserRecord, getProductlist } from "@/api/lucky";
import {
  // getVipPackages,
  getAdvanceOrder,
  getPayQrCode,
  getPayStatus,
} from "@/api/voucherCenter";
import { getCouponList } from "@/api/coupons";
import { logOut } from '@/api/user'
import { getWinDownloadUrl } from '@/api/footer'
import QRCode from "qrcodejs2";
import Login from "../login/lucky_login.vue";
// import mLogin from "../mobile/login/index.vue"
export default {
  components: {
    Login
  },
  data() {
    return {
      disableLucky: false,
      freeGame: [
        require('../../assets/imgs/luckyDraw/newyear/APEX.jpg'),
        require('../../assets/imgs/luckyDraw/newyear/csgo.jpg'),
        require('../../assets/imgs/luckyDraw/newyear/warzone.png'),
        require('../../assets/imgs/luckyDraw/newyear/gta5.png'),
        require('../../assets/imgs/luckyDraw/newyear/sugar.jpg'),
        require('../../assets/imgs/luckyDraw/newyear/rainbow.jpg'),
        require('../../assets/imgs/luckyDraw/newyear/rider.jpg'),
        require('../../assets/imgs/luckyDraw/newyear/thunder.jpg'),
        require('../../assets/imgs/luckyDraw/newyear/volorant.png'),
      ],
      first_h: 700,
      zoomValue: 1,
      showLoginDialogM: false,
      is_mobile: false,
      layerShowTips: false,
      layerShowRecord: false,
      dlUrl: '', //客户端下载地址
      timerId: null,
      qrcode: null,
      qrLoading: false,
      allCouponList: [],
      selectedItem: {},
      layerShow: false,
      lastPrice: 0,
      pay_amount: 0,
      coupon_discount: 0,
      form: {
        couponId: 0,
        payWay: "wx_qrcode",
      },
      payWays: [
        { value: "wx_qrcode", label: "微信" },
        { value: "ali_qrcode", label: "支付宝" },
      ],
      activeInfo: {}, // 充值活动信息
      loginActiveInfo: {}, // 登录活动信息
      records: [], // 活动中奖记录
      userRecord: [], // 用户中奖记录
      productList: [], // 在售套餐
      activeProduct: [],  // 活动参与套餐
      rest_count: 0, // 充值剩余抽奖次数
      login_rest_count: 0, // 登录剩余抽奖次数
      blocks: [
        { 
          padding: "30px" ,
          imgs: [{
            src: 'http://dl.js.3dmjiasu.com/upload/res/1611665920672206848.png',
            width: '880px',
            height: '640px'
          }]
        },
      ],
      prizes: [
        { x: 0, y: 0, fonts: [{ text: "暂无奖品", top: "40%", fontColor: '#FFF' }] },
        { x: 1, y: 0, fonts: [{ text: "暂无奖品", top: "40%", fontColor: '#FFF'  }] },
        { x: 2, y: 0, fonts: [{ text: "暂无奖品", top: "40%", fontColor: '#FFF'  }] },
        { x: 2, y: 1, fonts: [{ text: "暂无奖品", top: "40%", fontColor: '#FFF'  }] },
        { x: 2, y: 2, fonts: [{ text: "暂无奖品", top: "40%", fontColor: '#FFF'  }] },
        { x: 1, y: 2, fonts: [{ text: "暂无奖品", top: "40%", fontColor: '#FFF'  }] },
        { x: 0, y: 2, fonts: [{ text: "暂无奖品", top: "40%", fontColor: '#FFF'  }] },
        { x: 0, y: 1, fonts: [{ text: "暂无奖品", top: "40%", fontColor: '#FFF'  }] },
      ],
      activeStyle: {
        background: "rgba(0,0,0,0)"
      },
      defaultStyle: {
        // background: '#6c2bd3', 
        fontSize: "12",
        borderRadius: '10px',
        wordWrap: false
      },
      defaultConfig: {
        gutter: 20
      },
    };
  },
  computed: {
    couponList() {
      const { allCouponList, selectedItem } = this;
      const now = Date.now();
      return allCouponList
        .filter((item) => {
          const supportProducts = JSON.parse(item.support_product || "[]");
          return supportProducts.some((id) => {
            // let lastPrice = this.getLastPrice(selectedItem, item)
            // lastPrice > 0 &&
            return (
              parseInt(id) === selectedItem.info.ID &&
              now > new Date(item.valid_begin_time).getTime() &&
              now < new Date(item.valid_end_time).getTime()
            );
          });
        })
        .map((it) => ({
          ...it,
          label:
            (it.type === 2 ? `￥${it.discount}` : `${it.discount_rate}折`) +
            `——${it.name}`,
        }));
    },
    token() {
      return this.$store.getters.token
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
    isVip() {
      return this.userInfo.is_vip;
    },
    showLoginDialog: {
      get() {
        return this.$store.state.app.showLoginDialog;
      },
      set(show) {
        this.$store.commit("app/setShowLogin", show);
      },
    },
    buttons() {
      return [
        {
          x: 1,
          y: 1,
          background: "transparent",
          fonts: [
            // { text: "点击抽奖", top: "30%",fontColor: '#FFF',fontSize: '20px',fontWeight: 600 },
            { text: `${this.rest_count}`, top: "80%", left: '50px',fontColor: '#EFF00C',fontSize: '16px' }
          ],
          imgs:[{src: 'http://dl.js.3dmjiasu.com/upload/res/1612335991673393152.png',width: '233px',height: '186px'}]
        },
      ]
    }
  },
  watch: {
    token(newVal,oldVal){
      if(newVal != oldVal){
        this.getCoupons()
        this.getActive()
      }
    }
  },
  created() {
    console.log(document.body.clientWidth)
    // const cWidth = document.body.clientWidth
    // const widthImg = 1920
    // this.first_h = cWidth * (700 / widthImg)
    // this.avtive_mt = -240 * (this.first_h / 700)
    // this.getProductList()
    const { token, weixin } = this.$route.query
    this.is_mobile = weixin ? true : false
    // const zoomValue = cWidth / 1920
    // this.zoomValue = zoomValue
    // document.body.style.zoom = zoomValue
    if(token){
      this.$store.dispatch('user/swapToken',token).then(() =>{
        this.$router.push('/luckyDraw')
      })
    }
    this.getActive()
    if(this.token){
      this.getCoupons()
    }
    // this.getWinHref()
    // this.getRecord()
  },
  methods: {
    //点击向下箭头滚动至抽奖位置
    toElementFuc(id){
      let toElement = document.getElementById(id)
      toElement.scrollIntoView({behavior: 'smooth'})
    },
    // 奖品详情处理
    showPrizeDetail(row){
      let txt = ''
      let arr = ['188元现金红包','8元现金红包']
      if(row.resource_type == "conversion_code"){
        if(arr.includes(row.prize_name)){
          txt = '请截图联系客服领取(联系方式请查看活动规则)'
        }else{
          txt = row.resource_name
        }
      }else{
        txt = '已发放至账户卡券包'
      }
      return txt
    },
    // 昵称/手机号脱敏处理
    formatName(name,type = 'name') {
      let newStr;
      if (name.length === 2) {
          newStr = name.substr(0, 1) + '*';
      } else if (name.length > 2) {
          let char = '';
          let len = name.length - 2 > 4 ? 4 : name.length - 2
          for (let i = 0; i < len; i++) {
              char += '*';
          }
          if(type == 'phone'){
            newStr = name.substr(0, 3) + char + name.substr(-4, 4);
          }else{
            newStr = name.substr(0, 1) + char + name.substr(-1, 1);
          }
      } else {
          newStr = name;
      }
      return newStr;
    },
    // 获取客户端下载地址
    getWinHref() {
      getWinDownloadUrl({
        channel_number: process.env.VUE_APP_CHANNEL || '',
      }).then((data) => {
        if (data.success) {
          this.dlUrl = data.url
          window.open(data.url,'_self')
        }
      })
    },
    // 获取优惠券列表
    getCoupons() {
      getCouponList()
        .then(({ list }) => {
          this.allCouponList = list || [];
          // if (select)
          //   setTimeout(() => {
          //     const firstItem = this.couponList[0];
          //     this.form.couponId = firstItem ? firstItem.id : "";
          //     this.setLastPrice();
          //   });
        })
        .catch(() => {});
    },
    // 计算最终金额
    getLastPrice(item, couponObj) {
      const minPrice = 0.01;
      let nowPrice = this.getNowPrice(item);
      if (isNaN(nowPrice)) return minPrice;
      if (couponObj) {
        switch (couponObj.type) {
          case 1:
            nowPrice *= couponObj.discount_rate / 10;
            break;
          case 2:
            nowPrice -= couponObj.discount;
            break;
        }
      }
      if (nowPrice < minPrice) nowPrice = minPrice;
      return Math.round(nowPrice * 100) / 100;
    },
    setLastPrice() {
      const {
        couponList,
        form: { couponId },
      } = this;
      const couponObj = couponList.find((it) => it.id === couponId);
      this.lastPrice = this.getLastPrice(this.selectedItem, couponObj);
      // console.log(this.lastPrice)
    },
    // 打开中奖记录列表
    openLayerRecord(){
      if(this.token){
        this.layerShowRecord = true
        const params = {
          page: 1,
          page_size: 100
        }
        getUserRecord(this.activeInfo.id, params).then(res =>{
          this.userRecord = res.data.list || []
          this.userRecord.sort((a,b)=>{
            return new Date(b.draw_at) - new Date(a.draw_at)
          })
        })
      }else{
        this.$confirm("请先登录您的账号！", {
          title: "提示",
        })
          .then(() => {
            this.setShowLogin();
          })
          .catch(() => {});
        return;
      }
    },
    // 关闭中奖记录列表
    closeLayerRecord(){
      this.layerShowRecord = false
    },
    checkPayWay(e){
      this.form.payWay = e
      this.createPreOrder(this.selectedItem)
    },
    // 购买
    purchase(item) {
      console.log(item)
      if (!this.token) {
        this.$confirm("请先登录您的账号！", {
          title: "提示",
        })
          .then(() => {
            this.setShowLogin();
          })
          .catch(() => {});
        return;
      }
      this.layerShow = true;
      this.selectedItem = item
      // 自动选择最优的优惠券
      let index, price
      this.couponList.forEach((it, i) => {
        const cost = this.getLastPrice(item.info, it)
        if (i === 0 || price > cost) {
          price = cost
          index = i
        }
      })
      this.form.couponId = isNaN(index) ? '' : this.couponList[index].id
      console.log(this.form)
      // this.setLastPrice()
      // console.log(item)
      this.createPreOrder(item);
    },
    // 生成预订单
    createPreOrder(item) {
      this.clearTimerId();
      const {
        // selectedItem: { id, product_name: productName },
        form: { couponId ,payWay },
      } = this;
      let param = {
        product_id: item.info.ID + "", // 商品id
        product_name: item.info.product_name, // 商品名称
        order_channel: "官网", // 下单渠道.如果是客户端，请传：加速器客户端，如果是官网，请传：官网
        pay_way: payWay, // 支付方式。如果是支付宝支付，请传：ali_qrcode,如果微信支付，请传：wx_qrcode
        user_id: this.userInfo.user_id,
        coupon_id: couponId || 0,
      };
      this.qrLoading = true;
      getAdvanceOrder(param).then((data) => {
        if (data.success == true) {
          this.pay_amount = data.data.pay_amount
          this.coupon_discount = data.data.coupon_discount
          // localStorage.setItem('order_id', data.data.out_order_sn)
          // 生成二维码
          const outOrderSn = (this.outOrderSn = data.data.out_order_sn);
          this.getPayCode(outOrderSn);
          this.timerId = setInterval(this.payStatus, 3000, outOrderSn);
          // 订单状态查询
          this.payStatus(outOrderSn);
        }
      });
    },
    // 生成二维码
    getPayCode(ordersn) {
      var param = {
        out_order_sn: ordersn, //订单id
      };
      getPayQrCode(param)
        .then((res) => {
          this.qrLoading = false;
          const container = this.$refs.qrCode;
          if (this.qrcode) {
            this.qrcode.makeCode(res.url);
          } else {
            const { width, height } = container.getBoundingClientRect();
            this.qrcode = new QRCode(container, {
              text: res.url,
              width,
              height,
              colorDark: "#000000",
              colorLight: "#ffffff",
              correctLevel: 0,
            });
          }
          container.title = "";
        })
        .catch(() => {
          // this.qrLoading = false
        });
    },
    // 定时查询  订单状态查询
    payStatus(outOrderSn) {
      return new Promise((resolve, reject) => {
        getPayStatus({
          order_number: outOrderSn, //订单id
        })
          .then((data) => {
            if (data.code == 200 && data.status == "已付款") {
              this.paySuccess = true;
              this.payResultShow = true;
              setTimeout(() => {
                this.payResultShow = false;
              }, 3000);
              this.form.couponId = "";
              this.$store.dispatch("user/getUserInfo");
              this.closeLayer()
              this.$message.success('已获得抽奖次数，快去抽奖吧~')
              this.getLuckyDrawRestCount()
              resolve(true);
            } else if (data.code == 200 && data.status == "订单超时") {
              this.createPreOrder();
              resolve(false);
            } else {
              resolve(false);
            }
          })
          .catch(() => {
            this.paySuccess = false;
            this.payResultShow = true;
            setTimeout(() => {
              this.payResultShow = false;
            }, 3000);
            reject();
          });
      });
    },
    getPriceFloat(price) {
      let match = /(\.\d+)/.exec(price);
      return match ? match[0] : ".00";
    },
    clearTimerId() {
      if (this.timerId) {
        clearInterval(this.timerId);
        this.timerId = null;
      }
    },
    closeLayer() {
      this.clearTimerId();
      this.layerShow = false;
      // 重新获取优惠券
      this.getCoupons();
      // 购买的套餐有限制次数,就刷新商品列表
      if (this.selectedItem.limit_buy !== 0) {
        this.getActiveProduct();
      }
      this.outOrderSn = "";
    },
    // 登出系统
    logout() {
      logOut()
      this.rest_count = 0
      this.$store.dispatch('user/removeToken')
      window.localStorage.clear()
      if(this.$route.path === '/personal'){
        this.$router.push('/')
      }
    },
    // 点击抽奖按钮会触发star回调
    startCallback () {
      if(!this.token){
        this.$confirm("请先登录您的账号！", {
          title: "提示",
        })
          .then(() => {
            this.setShowLogin();
          })
          .catch(() => {});
        return;
      }
      if(this.disableLucky) return
      if(this.rest_count < 1) {
        return this.$message.error('抽奖次数不足，购买活动套餐可获得额外抽奖次数')
      }
      // 调用抽奖组件的play方法开始游戏
      this.disableLucky = true
      this.$refs.myLucky.play()
      // 登录活动有抽奖次数时，消耗登录抽奖次数，没有消耗充值抽奖次数
      let activeId = this.activeInfo.id
      // 调用抽奖方法
      startLuckyDraw(activeId).then(res =>{
        let flag = true
        this.prizes.forEach((item,index) =>{
          if(item.fonts[0].text == res.data.prize_name && flag){
            this.$refs.myLucky.stop(index)
            flag = false
            setTimeout(()=>{
              this.$message.success(`恭喜获得${res.data.prize_name}`)
              this.getLuckyDrawRestCount()
            },5000)
          }
        })
      }).catch(()=>{
        this.$refs.myLucky.stop(8)
        this.$message.error('网络开小差了~请刷新页面重试')
        this.getLuckyDrawRestCount()
      })
    },
    // 抽奖结束会触发end回调
    endCallback () {
      this.disableLucky = false
      this.getCoupons()
      this.getRecord()
    },
    // 打开登录页面
    openLoginPage() {
      this.setShowLogin();
    },
    setShowLogin(show = true) {
      this.$store.commit("app/setShowLogin", show);
    },
    // 获取活动
    getActive() {
      getActiveInfo()
        .then((res) => {
          res.data.forEach((item) => {
            if (item.type == "recharge") {
              this.activeInfo = item;
              this.dealPrizeList(item.draw_task_prizes)
              localStorage.setItem("active", JSON.stringify(item));
              this.getActiveProduct(item.draw_type_details);
            }
          })
          if(this.token){
            this.getLuckyDrawRestCount()
          }
          this.getRecord();
        })
        .catch(() => {
          // console.log(err);
          this.layerShowTips = true
          // this.$message.error("获取活动信息失败！");
        }).finally(()=>{
          if(JSON.stringify(this.activeInfo) == '{}'){
            this.layerShowTips = true
          }
        })
    },
    // 奖品数据处理
    dealPrizeList(info){
      const position = [
        { x: 0, y: 0 },
        { x: 1, y: 0 },
        { x: 2, y: 0 },
        { x: 2, y: 2 },
        { x: 1, y: 2 },
        { x: 0, y: 1 },
      ]
      const rows = [
        {row :1},
        {row :1},
        {row :2},
        {row :1},
        {row :1},
        {row :2},
      ]
      this.prizes = []
      info.forEach((item,index) =>{
        let res = {...position[index],...rows[index],fonts: [{ text: item.prize.name, top: "70px", fontColor: 'transparent' }],imgs:[{src: item.prize.pictures[0], top: '0px',width: '233px',height: '168px',activeSrc: item.prize.pictures[1] || item.prize.pictures[0]}] }
        if(index == 2 || index == 5){
          res.imgs[0].height = '370px'
        }
        this.prizes.push(res)
      })
      console.log(this.prizes)
    },
    // 获取抽奖记录
    getRecord() {
      const data = {
        page: 1,
        page_size: 1000,
      };
      getLuckyDrawRecord(this.activeInfo.id, data).then((res) => {
        // console.log(res)
        this.records = res.data.list || [];
        if(this.records.length < 50){
          let prizelist = ['8元现金红包', '3DM加速器30天时长卡','3DM加速器7天时长卡','3DM加速器1天时长卡','3DM专属7折优惠券']
          let nameList = [
            'Nami严','童','艾特一下@','heap','啊哈','GAO','慌的一批','giao','我是小啊giao','流浪pig',
            '诗','钱','cocoa', '緣來遇見妳','遇见','清风逝～','穷的很','那年暖冬','Arthur','Morgan',
            '薛定谔的喵x','双鱼仔a','SadSakura','躲鑶鍀眼睛','疯子','梦花浮萍','a小时','[bbs','風霰','2048'
          ]
          let randomPrizeIndex, randomNameIndex
          for(let i = 0; i< 50;i++){
            randomPrizeIndex = parseInt(Math.random()*5)
            randomNameIndex = parseInt(Math.random()*30)
            this.records.push({
              user_name: nameList[randomNameIndex],
              prize_name: prizelist[randomPrizeIndex]
            })
          }
          this.records.sort(()=>{
            return 0.5 - Math.random()
          })
        }
      });
    },
    // 筛选抽奖套餐
    getActiveProduct(arr) {
      let result = [];
      getProductlist()
        .then(({ data }) => {
          this.productList = data;
          arr.forEach((item) => {
            data.forEach((it) => {
              if (item.label == it.ID) {
                item.info = it;
                result.push(item);
              }
            });
          });
          this.activeProduct = result;
        })
        .catch(() => {});
    },
    // 获取当前价格
    getNowPrice(item) {
      return this.isVip
        ? item.vip_price || item.product_price
        : item.product_price;
    },
    // 获取抽奖次数
    getLuckyDrawRestCount(){
      // console.log(this.activeInfo)
      getLuckyDrawCount(this.activeInfo.id).then(res =>{
        this.rest_count = res.data.rest_count || 0
      })
    }
  },
  
  beforeDestory() {
    this.clearTimerId();
  },
};
</script>

<style lang='scss' scoped>
/* 上下跳动动画 */
@keyframes bounce-css {
  0%,20%,50%,80%,100%{
    transform: translateY(0);
  }
  40%{
    transform: translateY(-10px);
  }
  60%{
    transform: translateY(-5px);
  }
}
.lucky_draw_wrap,
.first_wrap {
  width: 100%;
  color: #fff;
  background: #fff;
}
// 各屏title样式
.title_wrap{
  position: relative;
  width: 1400px;
  height: 245px;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  .title{
    height: 186px;
  }
  .decoration_l,.decoration_r{
    position: absolute;
  }
  .decoration_l{
    width: 80px;
    top: 133px;
    left: 264px;
  }
  .decoration_r{
    width: 120px;
    top: 18px;
    right: 283px;
  }
}
// 第一屏样式
.first_wrap {
  position: relative;
  z-index: 1;
  background:  url('../../assets/imgs/luckyDraw/newyear/head_bg.png') center/100% 100%;;
  .logo{
    position: absolute;
    top: 40px;
    left: 30px;
    width: 196px;
  }
  .login_wrap{
    position: absolute;
    top: 20px;
    right: 30px;
    height: 80px;
    font-size: 24px;
    padding: 20px 0;
    .btn{
      display: block;
      width: 120px;
      height: 35px;
      background: #B3411A;
      color: #fff;
      border-radius: 32px 32px 32px 32px;
      opacity: 1;
      text-align: center;
      line-height: 35px;
      font-size: 16px;
      margin-left: 35px;
      &:hover {
        background: #AE3B16;
      }
    }
    .personal{
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 80px;
      .avatar{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #313130;
        overflow: hidden;
        margin-right: 16px;
      }
      .userinfo{
        font-size: 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .logout_btn{
          color: #B3411A;
          cursor: pointer;
          &:hover{
            color: #AE3B16;
          }
        }
        .remainTime{
          color: #AE3B16;
        }
      }
    }
  }
}
.active_wrap{
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -240px;
  background: url('../../assets/imgs/luckyDraw/newyear/product_bg.png') center/100% 100%;
  width: 100%;
  height: 1030px;
  z-index: 9999;
  padding-top: 120px;
  .title_wrap{
    width: 945px;
    scale: .8;
    z-index: 99 ;
  }
  .product_wrap{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -100px;
    z-index: 99;
    .product{
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      margin: 0 40px;
      .left{
        margin-right: 10px;
        img{
          width: 43px;
          height: 206px;
        }
      }
      .right{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 40px;
        img{
          width: 300px;
        }
        .pay_btn{
          background: url('../../assets/imgs/luckyDraw/newyear/pay_btn.png') center/100% 100%;
          width: 148px;
          height: 55px;
          text-align: center;
          line-height: 50px;
          cursor: pointer;
        }
      }
    }
    .top{
      .product{
        .right{
          padding-top: 0;
        }
      }
    }
    .bottom{
      display: flex;
      flex-direction: row;
    }
  }
  .decoration_wrap{
    position: absolute;
    left: 0;
    top: 30px;
    width: 290px;
    height: 396px;
    z-index: 1;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .decoration_wrap_r{
    position: absolute;
    right: 0;
    bottom: -100px;
    width: 267px;
    height: 512px;
    z-index: 1;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.lucky_wrap {
  position: relative;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: -150px;
  background: url('../../assets/imgs/luckyDraw/newyear/bg_lucky.png') center/100% 100%;
  z-index: 999;
  padding-top: 100px;
  height: 1120px;
  .title_wrap{
    width: 945px;
    scale: .8;
    z-index: 99 ;
  }
  .draw_wrap{
    width: 1400px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin-top: -100px;
    z-index: 99;
    // background: url('../../assets/imgs/luckyDraw/luckydraw_bg.png') no-repeat center/100% 100%;
    .top{
      margin-top: 40px;
      width: 100%;
      text-align: center;
      display: flex;
      justify-content: center;
      .restChance{
        width: 425px;
        height: 60px;
        line-height: 60px;
        font-size: 24px;
        text-align: center;
        background: url('../../assets/imgs/luckyDraw/chance_bg.png') no-repeat center/100% 100%;
        .count{
          color: #FFDD4D;
        }
      }
    }
    .bottom{
      width: 100%;
      display: flex;
      flex-direction: row;
      margin: 40px 0 60px;
      padding: 0 100px;
      box-sizing: border-box;
      .left{
        cursor: pointer;
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .right{
        padding-right: 20px;
        box-sizing: border-box;
        .list{
          width: 260px;
          height: 640px;
          padding: 20px 2px;
          display: flex;
          flex-direction: column;
          align-items: center;
          background: url('../../assets/imgs/luckyDraw/newyear/record_bg.png') no-repeat center/100% 100%;
          .list_header{
            width: 125px;
            height: 28px;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .divider{
            width: 184px;
            height: 2px;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .seamless-warp {
            width: 100%;
            height: 550px;
            margin-top: 30px;
            overflow: hidden;
            cursor: pointer;
            .item_wrap{
              .item{
                width: 100%;
                // height: 80px;
                padding: 10px 0; 
                display: flex;
                flex-direction: column;
                align-items: center;
                font-size: 16px;
                .tips{
                  .user_name{
                    color: #FFFC7C;
                  }
                  .prize_name{
                    color: #FEF7D8;
                  }
                }
              }
            }
          }
          .list_footer{
            margin: 20px 0 0;
            width: 148px;
            height: 55px;
            text-align: center;
            line-height: 50px;
            color: #fff;
            font-size: 14px;
            background: url('../../assets/imgs/luckyDraw/newyear/btn_bg.png') center/100% 100%;
            cursor: pointer;
            span{
              display: block;
              height: 60px;
              // margin-top: -5px;
            }
          }
        }
      }
    }
  }
  .decoration_wrap{
    position: absolute;
    left: 0;
    bottom: -200px;
    width: 297px;
    height: 639px;
    z-index: 1;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.free_wrap{
  position: relative;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: -260px;
  padding-top: 250px;
  height: 1140px;
  background: url('../../assets/imgs/luckyDraw/newyear/free_bg.png') center/100% 100%;
  z-index: 99;
  .title_wrap{
    width: 933px;
    scale: .8;
    z-index: 99 ;
  }
  .free_game_wrap{
    background: url('../../assets/imgs/luckyDraw/newyear/game_bg.png') center/100% 100%;
    width: 980px;
    height: 564px;
    margin-top: -80px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    padding-top: 80px;
    padding-left: 30px;
    z-index: 99 ;
    .game{
      width: 150px;
      height: 225px;
      background: #D9D9D9;
      margin-right: 30px;
      margin-bottom: 10px;
      border-radius: 8px;
      overflow: hidden;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
  .decoration_wrap{
    position: absolute;
    right: 0;
    bottom: -200px;
    width: 263px;
    height: 399px;
    z-index: 1;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.rule_wrap{
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 60px;
  margin-top: -100px;
  padding: 100px;
  min-height: 933px;
  background: url('../../assets/imgs/luckyDraw/newyear/rule_bg.png') center/100% 100%;
  
  .title_wrap{
    width: 945px;
    scale: .8;
  }
  .rule{
    margin-top: -50px;
    font-size: 18px;
    width: 1200px;
    font-weight: MicrosoftYaHei, Avenir, Helvetica, Arial, sans-serif;
  }
}
.layer {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 630px;
  height: 350px;
  z-index: 10001;
  background: linear-gradient(180deg, #B3411A 0%, #AE3B16 100%);
  transform: translate(-50%, -50%);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.5);
  .layer-title {
    position: relative;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    border-bottom: 1px solid rgba(223, 223, 255, 0.08);
    .title {
      color: rgba(255, 255, 255, 0.6);
    }
    .el-icon-close {
      position: absolute;
      top: 12px;
      right: 12px;
      cursor: pointer;
      color: rgba(255, 255, 255, 0.6);
      &:hover {
        color: rgba(255, 255, 255, 0.7);
      }
    }
  }
  .layer-content {
    display: flex;
    padding: 38px 0 0 90px;
    .pay-code {
      position: relative;
      width: 213px;
      height: 213px;
      padding: 16px;
      user-select: none;
      background: url("../../assets/imgs/voucherCenter/qr-border2.png")
        no-repeat top left/cover;

      .qr-code {
        width: 181px;
        height: 181px;
        background-color: rgba($color: #000000, $alpha: 0.8);
        &.loading {
          filter: blur(4px);
          cursor: wait;
        }
        /deep/ img{
          width: 100%;
          height: 100%;
        }
      }
      .scan {
        position: absolute;
        top: 6px;
        left: 8px;
        right: 8px;
        height: 16px;
        background: linear-gradient(
          rgba(0, 180, 255, 0.1),
          rgba(0, 180, 255, 0.6)
        );
        animation: move 2s infinite linear;
      }
      .qr-loading {
        position: absolute;
        width: 32px;
        height: 32px;
        z-index: 1;
        left: 90px;
        top: 90px;
        cursor: wait;
        background-size: 32px 32px;
        background-position: center;
        transform-origin: center;
        // transform: translate(-50%, -50%);
        animation: loading 1s infinite linear;
        background-image: url("../../assets/imgs/voucherCenter/loading.png");
      }
    }
    .pay-info {
      flex: 1;
      display: flex;
      padding-left: 50px;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      .sum {
        text-align: left;
        padding-left: 20px;
        color: #EFF00C;
        font-weight: bold;
        // color: #ff6000;
        font-size: 34px;
        /* .integer {
          margin-left: 4px;
          font-size: 32px;
        } */
        .icon {
          font-size: 20px;
          margin-right: 6px;
        }
      }
      .discount{
        padding-left: 20px;
        color: #ff6000;
      }
      .tips {
        margin-top: 36px;
        color: #fff;
      }
      .operate {
        .el-button {
          width: 120px;
          // padding: 10px 25px;
          border-radius: 18px;
          border: none;
          &:hover {
            opacity: 0.9;
          }
          &:active {
            opacity: 0.7;
          }
        }
        .cancel {
          margin-right: 22px;
          background-color: rgba(255, 255, 255, 0.3);
        }
        .comleted {
          background-color: rgba(11, 112, 236, 1);
        }
      }
    }
  }
}
.layer-shadow {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 9999;
  background-color: rgba($color: #000000, $alpha: 0.3);
}
.payWay{
  width: 160px;
  height: 45px;
  line-height: 45px;
  margin-top: 20px;
  border: 1px solid #FAD976;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  &.wechat::before{
    display: block;
    content: '';
    width: 26px;
    height: 26px;
    background: url('../../assets/imgs/luckyDraw/newyear/weixin.png') no-repeat center/100% 100%;
    margin-right: 6px;
  }
  &.alipay::before{
    display: block;
    content: '';
    width: 26px;
    height: 26px;
    background: url('../../assets/imgs/luckyDraw/newyear/zhifubao.png') no-repeat center/100% 100%;
    margin-right: 6px;
  }
  &.selected{
    background: linear-gradient(123deg, #FBDE78 0%, #EA7547 100%);
    &.wechat::before{
      background: url('../../assets/imgs/luckyDraw/newyear/weixin_s.png') no-repeat center/100% 100%;
    }
    &.alipay::before{
      background: url('../../assets/imgs/luckyDraw/newyear/zhifubao_s.png') no-repeat center/100% 100%;
    }
  }
}
.dl_btn{
  position: fixed;
  right: 20px;
  top: 30%;
  width: 200px;
  // height: 70px;
  cursor: pointer;
  z-index: 99999;
}
@keyframes move {
  from {
    top: 6px;
  }
  50% {
    top: 190px;
  }
  to {
    top: 6px;
  }
}
@keyframes loading {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

/deep/ .record-dialog,
/deep/ .tips-dialog,
/deep/ .login-dialog{
  background: linear-gradient(180deg, #B3411A 0%, #AE3B16 100%);
}
/deep/ .el-dialog__title,
/deep/ .el-dialog__headerbtn .el-dialog__close,
/deep/ .el-table__empty-text{
  color: #fff;
}
/*最外层透明*/
::v-deep .el-table,
::v-deep .el-table__expanded-cell {
  background-color: transparent !important;
  border: none;
}
/* 表格内背景颜色 */
::v-deep .el-table th,
::v-deep .el-table tr,
::v-deep .el-table td {
  background-color: transparent !important;
  border: none;
}
::v-deep .el-table--border::after, .el-table--group::after, .el-table::before{
  background-color: transparent !important;
}

/deep/ .tips-dialog .tips{
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  span{
    font-size: 24px;
  }
  .tip_btn{
    width: 120px;
    padding: 6px;
    text-align: center;
    background: linear-gradient(123deg, #FBDE78 0%, #EA7547 100%);
    border-radius: 50px;
    font-size: 16px;
    cursor: pointer;
    margin-top: 60px;
  }
}
// class="el-message el-message--success"
</style>
<style lang='scss'>
/deep/ .el-message--success{
  background-color: #B3411A;
}
/deep/ .el-message--error{
  background-color: #EA7547;
}
</style>